/* Copyright 2015 Bloomberg Finance L.P.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var widgets = require("jupyter-js-widgets");
var d3 = require("d3");
var utils = require("./utils");

var Tooltip = widgets.DOMWidgetView.extend({

    initialize: function() {
        this.setElement(document.createElement("div"));
        this.d3el = d3.select(this.el);
        Tooltip.__super__.initialize.apply(this, arguments);
    },

    render: function() {
        this.parent = this.options.parent;
        this.update_formats();
        this.create_listeners();
        this.create_table();
    },

    create_listeners: function() {
        this.listenTo(this.parent, "update_tooltip", this.update_tooltip);
        this.model.on_some_change(["fields", "show_labels", "labels"], this.create_table, this);
        this.listenTo(this.model, "change:formats", this.update_formats);
    },

    update_formats: function() {
        var fields = this.model.get("fields");
        var formats = this.model.get("formats");
        this.tooltip_formats = fields.map(function(field, index) {
            var fmt = formats[index];
            if(fmt === undefined || fmt === "") {
                return function(d) { return d; };
            } else {
                if(utils.is_valid_time_format(fmt)) {
                    return d3.time.format(fmt);
                }
                else {
                    return d3.format(fmt);
                }
            }
        });
    },

    update_tooltip: function(data) {
        //data is a dictionary passed by the parent along with the update_
        //tooltip event. Responsibility of the mark to pass the data
        var that = this;
        this.d3el.select("table")
            .selectAll("tr")
            .select(".datavalue")
            .text(function(datum, index) {
                return that.tooltip_formats[index](data[datum]);
            });
    },

    create_table: function() {
        var fields = this.model.get("fields");
        var labels = this.model.get("labels");
        var ind = labels.length;
        for (; ind < fields.length; ind++) {
            labels[ind] = fields[ind];
        }

        this.d3el.select("table").remove();
        var tooltip_table = this.d3el.append("table")
            .selectAll("tr").data(fields);

        tooltip_table.exit().remove();
        var table_rows = tooltip_table.enter().append("tr")
                            .attr("class", "datarow");
        if(this.model.get("show_labels")) {
            table_rows.append("td")
                .text(function(datum, index) { return labels[index]; })
                .attr("class", "tooltiptext datafield");
        }
        table_rows.append("td")
            .attr("class", "tooltiptext datavalue");
        this.update_formats();
    }
});

module.exports = {
    Tooltip: Tooltip
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/Tooltip.js
 ** module id = 67
 ** module chunks = 0
 **/